import CustomButton from "components/button";
import DateInput from "components/fields/DateInput";
import SelectInput, { DynamicOption } from "components/fields/SelectInput";

interface ConsumptionChartFilterProps {
  tagSelect: DynamicOption[] | null;
  tag: DynamicOption | null;
  setTag: React.Dispatch<any>;
  userSelect: DynamicOption[] | null;
  user: DynamicOption | null;
  setUser: React.Dispatch<any>;
  projectSelect: DynamicOption[] | null;
  project: DynamicOption | null;
  setProject: React.Dispatch<any>;
  typeSelect: DynamicOption[] | null;
  type: DynamicOption | null;
  setType: React.Dispatch<any>;
  fromDate?: any;
  setFromDate?: React.Dispatch<any>;
  tillDate?: any;
  setTillDate?: React.Dispatch<any>;
  update?: any;
}

const ConsumptionChartFilter = (props: ConsumptionChartFilterProps) => {
  const {
    tagSelect,
    tag,
    setTag,
    userSelect,
    user,
    setUser,
    projectSelect,
    project,
    setProject,
    typeSelect,
    type,
    setType,
    fromDate,
    setFromDate,
    tillDate,
    setTillDate,
    update,
  } = props;

  return (
    <div className="space-y-3 text-xs leading-tight">
      {fromDate ? (
        <div className="flex flex-col items-end justify-between md:flex-row">
          <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3">
            <div className="scale-95 transform">
              <DateInput
                label="تاریخ شروع"
                value={fromDate}
                onChange={(date: any) => {
                  setFromDate(date);
                  setTimeout(update, 0);
                }}
              />
            </div>
            <div className="scale-95 transform">
              <DateInput
                label="تاریخ پایان"
                value={tillDate}
                onChange={(date: any) => {
                  setTillDate(date);
                  setTimeout(update, 0);
                }}
              />
            </div>
          </div>
        </div>
      ) : null}

      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-4">
        {/* shrink each select by scaling its container */}
        <div className="scale-95 transform">
          <SelectInput
            label="دسته بندی"
            placeholder="دسته بندی مورد نظر را انتخاب کنید"
            dynamicOptions={tagSelect}
            state={tag}
            setState={setTag}
            isMandatory
          />
        </div>

        <div className="scale-95 transform">
          <SelectInput
            label="پروژه"
            placeholder="پروژه مورد نظر را انتخاب کنید"
            dynamicOptions={projectSelect}
            state={project}
            setState={setProject}
          />
        </div>

        <div className="scale-95 transform">
          <SelectInput
            label="نوع کنتور"
            placeholder="نوع کنتور مورد نظر را انتخاب کنید"
            dynamicOptions={typeSelect}
            state={type}
            setState={setType}
          />
        </div>

        <div className="scale-95 transform">
          <SelectInput
            label="کاربر"
            placeholder="کاربر مورد نظر را انتخاب کنید"
            dynamicOptions={userSelect}
            state={user}
            setState={setUser}
          />
        </div>
      </div>
    </div>
  );
};

export default ConsumptionChartFilter;
